// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"0b352754d109fa1a","4439":"f5af9de19f462575","5801":"89af24a57ec3e239","7744":"9f465348b160c52e","7746":"45300ab312bc0dde","9591":"5fe9b3a1a76308c1","9860":"2f338d617a56a702"}[chunkId] + ".1779977599142.js";
};